<template>
  <div class="editor_main df js ac">
    <div class="vue-quill-editor flex">
      <!-- 图片上传组件 -->
      <el-upload
        class="editor-avatar-uploader"
        v-show="false"
        :action="$Base_Upload_Url()"
        :name="uploadConfig.uploadImage.name"
        :headers="uploadConfig.uploadImage.header"
        :show-file-list="false"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :before-upload="beforeUpload"
      ></el-upload>
      <!-- 视频上传组件 -->
      <el-upload
        class="editor-video-uploader"
        v-show="false"
        :action="$Base_Upload_Url()"
        :name="uploadConfig.uploadVideo.name"
        :headers="uploadConfig.uploadVideo.header"
        :show-file-list="false"
        :on-success="uploadVideoSuccess"
        :on-error="uploadError"
        :before-upload="beforeUpload"
      ></el-upload>
      <quill-editor
        style="position: relative; z-index: 1"
        ref="myQuillEditor"
        v-model="html"
        :options="editorOption"
        @blur="onEditorBlur($event)"
        @focus="onEditorFocus($event)"
        @change="onEditorChange($event)"
      />
    </div>
    <Mobile :content="html" />
  </div>
</template>
<script>
import Mobile from "../Mobile";
import { quillEditor, Quill } from "vue-quill-editor";
import ImageResize from "quill-image-resize-module"; // 图片缩小放大插件
import { ImageDrop } from "quill-image-drop-module"; // 拖动加载图片组件。
import { ImageExtend } from "quill-image-paste-module";
Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);
Quill.register("modules/ImageExtend", ImageExtend);
//------------------------------------------------------工具栏配置项
// 设置字体大小
const fontSizeStyle = Quill.import("attributors/style/size"); // 引入这个后会把样式写在style上
fontSizeStyle.whitelist = [
  "10px",
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "24px",
  "28px",
  "32px",
  "36px",
];
Quill.register(fontSizeStyle, true);
// 设置字体样式
const Font = Quill.import("attributors/style/font"); // 引入这个后会把样式写在style上
const fontList = [
  { name: "宋体", value: "SimSun" },
  { name: "黑体", value: "SimHei" },
  {
    name: "微软雅黑",
    value: "Microsoft YaHei",
  },
  { name: "微软正黑体", value: "Microsoft JhengHei" },
  { name: "新宋体", value: "NSimSun" },
  // { name: "新细明体", value: "PMingLiU" },
  // { name: "细明体", value: "MingLiU" },
  // { name: "标楷体", value: "DFKai-SB" },
  { name: "仿宋", value: "FangSong" },
  { name: "楷体", value: "KaiTi" },
  // { name: "仿宋_GB2312", value: "FangSong_GB2312" },
  // { name: "楷体_GB2312", value: "KaiTi_GB2312" },
  // { name: "华文细黑", value: "STHeiti Light [STXihei],STXihei" },
  // { name: "华文黑体", value: "STHeiti" },
  // { name: "华文楷体", value: "STKaiti" },
  // { name: "华文宋体", value: "STSong" },
  // { name: "华文仿宋", value: "STFangsong" },
  { name: "隶书", value: "LiSu" },
  { name: "幼圆", value: "YouYuan" },
  // { name: "华文中宋", value: "STZhongsong" },
  { name: "方正舒体", value: "FZShuTi" },
  { name: "方正姚体", value: "FZYaoti" },
  { name: "华文彩云", value: "STCaiyun" },
  { name: "华文琥珀", value: "STHupo" },
  { name: "华文隶书", value: "STLiti" },
  { name: "华文行楷", value: "STXingkai" },
  { name: "华文新魏", value: "STXinwei" },
  { name: "苹果苹方", value: "PingFang SC" },
];

const fonts = [];

fontList.forEach((value) => {
  fonts.push(value.value);
});

Font.whitelist = fonts; // 将字体加入到白名单
Quill.register(Font, true);
import Parchment from "parchment";
//目的是修改富文本内容居中不了的问题
let config = {
  scope: Parchment.Scope.BLOCK,
  whitelist: ["right", "center", "justify"],
};
let AlignStyle = new Parchment.Attributor.Style("align", "text-align", config);
export { AlignStyle };
var Align = Quill.import("attributors/style/align");
Align.whitelist = ["right", "center", "justify"];
Quill.register(Align, true);
// 工具栏
const toolbarOptions = [
  ["clean"],
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
  [{ align: [] }], // 对齐方式-----[{ align: [] }]
  [{ size: fontSizeStyle.whitelist }], // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
  [{ font: fonts }], // 字体种类-----[{ font: [] }]
  [{ header: [1, 2, 3, 4, 5, 6] }], // 标题
  [{ direction: "ltl" }], // 文本方向-----[{'direction': 'rtl'}]
  [{ direction: "rtl" }], // 文本方向-----[{'direction': 'rtl'}]
  [{ indent: "-1" }, { indent: "+1" }], // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
  [{ script: "sub" }, { script: "super" }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
  ["blockquote", "code-block"], // 引用  代码块-----['blockquote', 'code-block']
  // ["clean"], // 清除文本格式-----['clean']
  ["image", "video"], // 链接、图片、视频-----['link', 'image', 'video']
];

export default {
  name: "VueQuillEditor",
  components: {
    quillEditor,
    Mobile,
  },
  props: {
    value: {
      type: [Number, Object, Array, String],
      default: "",
    },
  },
  data() {
    return {
      html: this.value,
      editorOption: {
        placeholder: "请输入详情介绍...",
        theme: "snow", // or 'bubble'
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image(value) {
                if (value) {
                  // 触发input框选择图片文件
                  document
                    .querySelector(".editor-avatar-uploader input")
                    .click();
                } else {
                  this.quill.format("image", false);
                }
              },
              video(value) {
                if (value) {
                  // 触发input框选择图片文件
                  document
                    .querySelector(".editor-video-uploader input")
                    .click();
                } else {
                  this.quill.format("video", false);
                }
              },
              link(value) {
                if (value) {
                  var href = prompt("请输入url");
                  this.quill.format("link", href);
                } else {
                  this.quill.format("link", false);
                }
              },
            },
          },
          imageDrop: true,
          imageResize: {
            displayStyles: {
              backgroundColor: "black",
              border: "none",
              color: "white",
            },
            modules: ["Resize", "DisplaySize", "Toolbar"],
          },
          ImageExtend: {
            loading: true,
            name: "image",
            change: (xhr, FormData) => {
              // FormData.append("token");
            },
            action: this.$Base_Upload_Url(),
            response: (res) => {
              return res.data;
            },
          },
        },
      },
      // 上传设置
      uploadConfig: {
        uploadImage: {
          uploadUrl: "/api/upload/uploadImage",
          name: "file",
          header: {},
        },
        uploadVideo: {
          uploadUrl: "/api/upload/uploadVideo",
          name: "file",
          header: {},
        },
      },
      isShow: false,
    };
  },
  watch: {
    html: {
      handler(newValue) {
        this.$emit("input", newValue);
      },
      deep: true,
    },
    value: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) this.html = newValue;
      },
      deep: true,
    },
  },
  mounted() {
    this.$refs.myQuillEditor.quill.enable(false);

    this.initMounted();
  },
  methods: {
    /**
     * 上传成功
     * @param {*} res
     * @param {*} file
     */
    uploadSuccess(res, file) {
      const { quill } = this.$refs.myQuillEditor;

      // 如果上传成功
      if (res.code === 200) {
        // 获取光标所在位置
        let length = quill.getSelection() ? quill.getSelection().index : 0;
        // 插入图片  res.url为服务器返回的图片地址
        quill.insertEmbed(length, "image", this.$Base_Url(res.url));
        // 调整光标到最后
        quill.setSelection(length + 1);
      }
      // loading动画消失
      this.loading = false;
    },
    /**
     * 上传成功
     * @param {*} res
     * @param {*} file
     */
    uploadVideoSuccess(res, file) {
      const { quill } = this.$refs.myQuillEditor;
      // 如果上传成功
      if (res.code === 200) {
        // 获取光标所在位置
        let length = quill.getSelection() ? quill.getSelection().index : 0;
        // 插入图片  res.url为服务器返回的图片地址
        quill.insertEmbed(length, "video", this.$Base_Url(res.url));
        // 调整光标到最后
        quill.setSelection(length + 1);
      }
      // loading动画消失
      this.loading = false;
    },
    // 富文本图片上传失败
    uploadError() {
      // loading动画消失
      this.loading = false;

      this.$message.error("上传失败");
    },
    beforeUpload(file) {
      // const isJPG = file.type === "image/jpeg";
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      // if (!isLt2M) {
      //   this.$message.error("上传头像图片大小不能超过 2MB!");
      // }
      // return isJPG && isLt2M;
    },
    onEditorBlur() {
      //失去焦点事件
    },
    onEditorFocus() {
      //获得焦点事件
    },
    onEditorChange() {
      //内容改变事件
      this.$emit("input", this.html);
    },
    initMounted() {
      setTimeout(() => {
        this.isShow = true;

        this.$refs.myQuillEditor.quill.enable(true);
      }, 100);
    },
  },
};
</script>
<style lang="scss">
@import url("index.css");
</style>
